// extracted by mini-css-extract-plugin
export default {"container":"cp8LSv","screen":"Qt3Sp8","component":"DnhwaT","fixed":"HfRGHU","active":"Js_s6A","slide-down":"YIjWqn"};